import React from 'react';
import { X, Check } from 'lucide-react';
import ReviewStep from './ReviewStep';
import PaymentStep from './PaymentStep';
import ConfirmationStep from './ConfirmationStep';

const STEPS = [
  { n: 1, label: 'Review' },
  { n: 2, label: 'Payment' },
  { n: 3, label: 'Confirmation' },
];

const CheckoutModal = ({ open, onClose, checkoutStep, ...stepProps }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[62] flex items-center justify-center p-4 sm:p-8">
      <div className="absolute inset-0 bg-ink/60 backdrop-blur-sm" onClick={checkoutStep !== 3 ? onClose : undefined} />
      <div className="relative bg-surface w-full max-w-4xl max-h-[92vh] overflow-y-auto rounded-md shadow-2xl" data-lenis-prevent>
        <div className="flex items-center justify-between px-6 sm:px-8 py-5 border-b border-line sticky top-0 bg-surface z-10">
          <h2 className="font-display text-2xl text-ink">Checkout</h2>
          {checkoutStep !== 3 && (
            <button onClick={onClose} className="p-3 hover:bg-paper rounded-full transition-colors" aria-label="Close checkout">
              <X className="w-5 h-5" />
            </button>
          )}
        </div>

        <div className="flex items-center justify-center gap-3 py-6 px-6">
          {STEPS.map((step, i) => (
            <React.Fragment key={step.n}>
              <div className="flex flex-col items-center gap-1.5">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm ${
                  checkoutStep > step.n ? 'bg-accent text-paper' : checkoutStep === step.n ? 'bg-ink text-paper' : 'bg-paper text-ink-faint border border-line'
                }`}>
                  {checkoutStep > step.n ? <Check className="w-4 h-4" /> : step.n}
                </div>
                <span className="dpc-label text-[10px] text-ink-faint">{step.label}</span>
              </div>
              {i < STEPS.length - 1 && <div className={`w-10 sm:w-16 h-px ${checkoutStep > step.n ? 'bg-accent' : 'bg-line'}`} />}
            </React.Fragment>
          ))}
        </div>

        {checkoutStep === 1 && <ReviewStep {...stepProps} />}
        {checkoutStep === 2 && <PaymentStep {...stepProps} />}
        {checkoutStep === 3 && <ConfirmationStep onContinueShopping={stepProps.onContinueShopping} />}
      </div>
    </div>
  );
};

export default CheckoutModal;
